export const colors = {
    darkBlue: '#09101F',
    lightBlue: '#5AB9E5',
    green: '#CDC335',
    red: '#D22F1C',
    yellow: '#FC9E2A',
}

